import { Field, Entity } from "typegraph";
@Entity({one: "Bookmark"})
export default class Bookmark {

	@Field()
	public bookmarked: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Bookmark.ts